// Column Types
export const COLUMN_TYPES = {
  INICIO: 'INICIO',
  LEADS: 'LEADS',
  PROSPECTING: 'PROSPECTING',
  CONVERTED: 'CONVERTED',
  POSITIVE: 'POSITIVE',
  NEGATIVE: 'NEGATIVE',
};

// Column IDs
export const COLUMN_IDS = {
  [COLUMN_TYPES.INICIO]: 1,
  [COLUMN_TYPES.LEADS]: 2,
  [COLUMN_TYPES.PROSPECTING]: 3,
  [COLUMN_TYPES.CONVERTED]: 4,
  [COLUMN_TYPES.POSITIVE]: 5,
  [COLUMN_TYPES.NEGATIVE]: 6,
};

// Column Names
export const COLUMN_NAMES = {
  [COLUMN_IDS[COLUMN_TYPES.INICIO]]: 'Inicio',
  [COLUMN_IDS[COLUMN_TYPES.LEADS]]: 'Leads',
  [COLUMN_IDS[COLUMN_TYPES.PROSPECTING]]: 'Prospecção',
  [COLUMN_IDS[COLUMN_TYPES.CONVERTED]]: 'Convertidos',
  [COLUMN_IDS[COLUMN_TYPES.POSITIVE]]: 'Positivo',
  [COLUMN_IDS[COLUMN_TYPES.NEGATIVE]]: 'Negativo',
};

// Column Styles
export const COLUMN_STYLES = {
  [COLUMN_IDS[COLUMN_TYPES.INICIO]]: { 
    background: '#f5f5f5', 
    color: '#722ed1', 
    fontSize: '20px', 
    textAlign: 'center' 
  },
  [COLUMN_IDS[COLUMN_TYPES.LEADS]]: { 
    background: '#f5f5f5', 
    color: '#1890ff', 
    fontSize: '20px', 
    textAlign: 'center' 
  },
  [COLUMN_IDS[COLUMN_TYPES.PROSPECTING]]: { 
    background: '#f5f5f5', 
    color: '#1890ff', 
    fontSize: '20px', 
    textAlign: 'center' 
  },
  [COLUMN_IDS[COLUMN_TYPES.CONVERTED]]: { 
    background: '#f5f5f5', 
    color: '#000', 
    fontSize: '20px', 
    textAlign: 'center' 
  },
  [COLUMN_IDS[COLUMN_TYPES.POSITIVE]]: { 
    background: '#f5f5f5', 
    color: '#52c41a', 
    fontSize: '20px', 
    textAlign: 'center' 
  },
  [COLUMN_IDS[COLUMN_TYPES.NEGATIVE]]: { 
    background: '#f5f5f5', 
    color: '#f5222d', 
    fontSize: '20px', 
    textAlign: 'center' 
  },
};

// Display Modes
export const DISPLAY_MODES = {
  TABLE: 'table',
  FUNNEL: 'funnel',
};

// Routes
export const ROUTES = {
  [DISPLAY_MODES.TABLE]: '/crm/social-selling/table',
  [DISPLAY_MODES.FUNNEL]: '/crm/social-selling',
};

// Searchable Fields
export const SEARCHABLE_FIELDS = [
  'name',
  'email',
  'phone',
  'company',
  'additional_data.instagram',
  'additional_data.nextPendingTask.name'
];

// Default Column Configuration
export const DEFAULT_COLUMN_CONFIG = {
  minWidth: 300,
  padding: 0,
  fontSize: '20px',
  textAlign: 'center'
};

// Helper: getCadenceOption and getCadenceColor (stub, replace with real logic if needed)
export const getCadenceOption = (type) => {
  // TODO: Implement real mapping if needed
  return typeof type === 'string' ? type : `Etapa ${type}`;
};
export const getCadenceColor = (type) => {
  // TODO: Implement real color mapping if needed
  return '#007bff';
};

// Function to generate step columns based on cadence data
export const generateStepColumns = (cadenceData) => {
  if (!cadenceData || !cadenceData.data || !Array.isArray(cadenceData.data)) {
    return [];
  }

  return cadenceData.data.map((step, index) => {
    // Use the actual type string from the backend, or fallback to getCadenceOption if it's numeric
    let stepName;
    if (typeof step.type === 'string' && isNaN(parseInt(step.type))) {
      // Use the string type directly (e.g., "Msg1", "Curtir", "Áudio")
      stepName = step.type;
    } else {
      // Fallback to numeric type handling
      const stepType = parseInt(step.type);
      stepName = getCadenceOption(stepType) || step.type;
    }
    
    // For color, try to use numeric type if available, otherwise use default
    const stepColor = !isNaN(parseInt(step.type)) ? getCadenceColor(parseInt(step.type)) : '#007bff';
    
    return {
      id: `step_${step.uid}`,
      name: stepName,
      style: {
        background: '#f5f5f5',
        color: stepColor,
        fontSize: '20px',
        textAlign: 'center'
      },
      data: [],
      type: 'step',
      stepData: step,
      stepIndex: index
    };
  });
};

// Function to generate complete column structure
export const generateColumns = (cadenceData) => {
  const baseColumns = [
    {
      id: COLUMN_IDS[COLUMN_TYPES.INICIO],
      name: COLUMN_NAMES[COLUMN_IDS[COLUMN_TYPES.INICIO]],
      style: COLUMN_STYLES[COLUMN_IDS[COLUMN_TYPES.INICIO]],
      data: [],
      type: 'base',
    },
    {
      id: COLUMN_IDS[COLUMN_TYPES.LEADS],
      name: COLUMN_NAMES[COLUMN_IDS[COLUMN_TYPES.LEADS]],
      style: COLUMN_STYLES[COLUMN_IDS[COLUMN_TYPES.LEADS]],
      data: [],
      type: 'base',
    },
    // Steps will be inserted here
    {
      id: COLUMN_IDS[COLUMN_TYPES.POSITIVE],
      name: COLUMN_NAMES[COLUMN_IDS[COLUMN_TYPES.POSITIVE]],
      style: COLUMN_STYLES[COLUMN_IDS[COLUMN_TYPES.POSITIVE]],
      data: [],
      type: 'base',
    },
    {
      id: COLUMN_IDS[COLUMN_TYPES.NEGATIVE],
      name: COLUMN_NAMES[COLUMN_IDS[COLUMN_TYPES.NEGATIVE]],
      style: COLUMN_STYLES[COLUMN_IDS[COLUMN_TYPES.NEGATIVE]],
      data: [],
      type: 'base',
    }
  ];
  const stepColumns = generateStepColumns(cadenceData);
  // Insert step columns between Leads and Positivo
  return [
    baseColumns[0], // Inicio
    baseColumns[1], // Leads
    ...stepColumns,
    baseColumns[2], // Positivo
    baseColumns[3]  // Negativo
  ];
}; 